import { Fragment } from "react";
import { ChevronRight } from "lucide-react";

export default function PipelineBar({ stages }) {
  return (
    <div className="flex items-center gap-0 w-full px-4 py-2">
      {stages.map((stage, i) => (
        <Fragment key={stage.id}>
          <div
            className="flex-1 h-1.5 rounded-full"
            style={{ backgroundColor: stage.color, opacity: 0.2 }}
          >
            <div
              className="h-full rounded-full transition-all duration-500"
              style={{
                backgroundColor: stage.color,
                width: `${stage.conversion_anterior ?? 0}%`,
              }}
            />
          </div>
          {i < stages.length - 1 && (
            <ChevronRight className="w-4 h-4 text-slate-300 shrink-0 mx-1" />
          )}
        </Fragment>
      ))}
    </div>
  );
}
